import { createReducer, on, Action } from '@ngrx/store';

import * as PacksNotSavedChangesActions from './packs-not-saved-changes.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { BOMModel } from '@cpak/adp-cpak-quotes-service-models';
import { BOMPageData } from '@cpak/interfaces';
import { deepCopy } from '@cpak/shared/utils';

export const PACKS_NOT_SAVED_CHANGES_FEATURE_KEY = 'packsNotSavedChanges';

export interface PackNotSavedChangesEntity {
  id: string;
  // should contain the following properties: products, categories, attributeTypes
  packData: Partial<BOMPageData>;
  changedProducts: string[];
  bom: BOMModel;
}

export interface PacksNotSavedChangesPartialState {
  readonly [PACKS_NOT_SAVED_CHANGES_FEATURE_KEY]: EntityState<PackNotSavedChangesEntity>;
}

export const packsNotSavedChangesAdapter: EntityAdapter<PackNotSavedChangesEntity> =
  createEntityAdapter<PackNotSavedChangesEntity>();

export const initialPacksNotSavedChangesState: EntityState<PackNotSavedChangesEntity> =
  packsNotSavedChangesAdapter.getInitialState();

const reducer = createReducer(
  initialPacksNotSavedChangesState,
  on(PacksNotSavedChangesActions.updateNotSavedBOMForPack, (state, { packId, packData, changedProducts, bom }) => {
    const item = {
      id: packId,
      packData: deepCopy(packData),
      changedProducts: deepCopy(changedProducts),
      bom: deepCopy(bom),
    };
    return packsNotSavedChangesAdapter.upsertOne(item, state);
  }),
  on(PacksNotSavedChangesActions.removeNotSavedChangesForPack, (state, { packId }) =>
    packsNotSavedChangesAdapter.removeOne(packId, state)
  ),
  on(PacksNotSavedChangesActions.removeNotSavedChangesForAllPacks, state =>
    packsNotSavedChangesAdapter.removeAll(state)
  )
);

export function packsNotSavedChangesReducer(
  state: EntityState<PackNotSavedChangesEntity> | undefined,
  action: Action
): EntityState<PackNotSavedChangesEntity> {
  return reducer(state, action);
}
